<template>
	<el-dialog :visible.sync="pdfPreviewDialogVisible" width="70%" :before-close="handleClose" style="z-index: 999999999999999999;background: grey !important;">
		<!-- {{ `data:application/pdf;base64,${PDFPreviewData}` }} -->
		<pdf :src="`data:application/pdf;base64,${PDFPreviewData}`"></pdf>
	</el-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	data() {
		return {
			showPDFPreview: false
		};
	},
	computed: {
		...mapGetters(['pdfPreviewDialogVisible', 'PDFPreviewData'])
	},
	methods: {
		handleClose() {
			this.$store.commit('risolto/SET_PDF_PREVIEW_DIALOG_VISIBLE', false);
		}
	}
};
</script>

<style lang="scss" scoped></style>
